const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "role":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "role",
    reducer: reducer,
};

export default data;